import { render } from "./ToRef.vue?vue&type=template&id=41f88d7e"
import script from "./ToRef.vue?vue&type=script&lang=ts"
export * from "./ToRef.vue?vue&type=script&lang=ts"
script.render = render

export default script